<template>
    <div class="alertsWorker">

        <transition-group name="fade" mode="out-in" >
            <div  v-for="(alertMessage, alertMessageIndex) in alertsWorker"
                  v-bind:key="alertMessage.id"
                  v-bind:hasUnSnoozedAlert="openUnSnoozedAlert(alertMessage)"
            >
                <!-- MESSAGES TYPES-->
                <AlertWorkerCredit v-bind:alertMessage="alertMessage"
                                   v-if="alertMessage.type === 'worker_credit'"
                                   v-on:setAlertAsClosed="setAlertAsClosed(alertMessage, alertMessageIndex)"
                >
                </AlertWorkerCredit>

                <AlertDevis
                            v-bind:alertMessage="alertMessage"
                            v-bind:isSnoozedTimerEnable="isSnoozedTimerEnable"
                            v-on:setAlertAsClosed="setAlertAsClosed(alertMessage, alertMessageIndex)"
                            v-on:snoozeAlert="snoozeAlert(alertMessage, alertMessageIndex, $event)"
                            v-on:hideAlert="hideAlert(alertMessageIndex)"
                            v-on:openAlert="openAlert(alertMessage)"
                            v-if="alertMessage.type === 'devis_accepted'"
                >
                </AlertDevis>
                <AlertJobWarranty
                            v-bind:alertMessage="alertMessage"
                            v-bind:isSnoozedTimerEnable="isSnoozedTimerEnable"
                            v-on:setAlertAsClosed="setAlertAsClosed(alertMessage, alertMessageIndex)"
                            v-on:openAlert="openAlert(alertMessage)"
                            v-on:hideAlert="hideAlert(alertMessageIndex)"
                            v-on:snoozeAlert="snoozeAlert(alertMessage, alertMessageIndex, $event)"
                            v-if="alertMessage.type === 'job_warranty'"
                            v-show="isCreationDateNotTooOld(alertMessage.created_at)"
                >
                </AlertJobWarranty>

                <AlertInformation v-bind:alertMessage="alertMessage"
                          v-on:openAlert="openAlert(alertMessage)"
                          v-on:hideAlert="hideAlert(alertMessageIndex)"
                          v-on:setAlertAsClosed="setAlertAsClosed(alertMessage, alertMessageIndex)"
                          v-if="alertMessage.type === 'information'"
                >
                </AlertInformation>

                <AlertMissingWorkerLogo
                        v-bind:alertMessage="alertMessage"
                        v-bind:workerId="user.user_id"
                        v-bind:isSnoozedTimerEnable="isSnoozedTimerEnable"
                        v-on:setAlertAsClosed="setAlertAsClosed(alertMessage, alertMessageIndex)"
                        v-on:openAlert="openAlert(alertMessage)"
                        v-on:hideAlert="hideAlert(alertMessageIndex)"
                        v-on:snoozeAlert="snoozeAlert(alertMessage, alertMessageIndex, $event)"
                        v-if="alertMessage.type === 'worker_logo'"
                        v-show="isCreationDateNotTooOld(alertMessage.created_at)"
                >
                </AlertMissingWorkerLogo>

            </div>
        </transition-group>
        <div ref="snoozed-block"></div>
        <div v-if="hasUnSnoozedAlert" class="overlay_snoozed">
            <br>
            <br>
            <br>
            <h1 v-if="isSnoozedTimerEnable">{{'please wait'|trans}} {{ timeEnableViewSecond }}s.</h1>
            <h1 v-else>{{'Please be care of your tasks'|trans}} </h1>
        </div>
        <AlertBadges></AlertBadges>
    </div>
</template>

<script>

    import Routing from '../../backend-router';
    import AlertDevis from './AlertsType/AlertDevis';
    import AlertJobWarranty from "./AlertsType/AlertJobWarranty";
    import AlertInformation from "./AlertsType/AlertInformation";
    import AlertMissingWorkerLogo from "./AlertsType/AlertMissingWorkerLogo"
    import AlertWorkerCredit from "./AlertsType/AlertWorkerCredit"
    import AlertMissedJobs from '../MissedJobs/AlertMissedJobs'
    import VueScrollTo from "vue-scrollto";
	import AlertBadges from "./AlertsType/AlertBadges";

    export default {
        props: {
            user : Object
        },
        data() {
            return {
                alertsWorker : [],
                isSnoozedTimerEnable : false,
                timeEnableViewSecond : 0,
                hasUnSnoozedAlert : false,
                checkIfalertsWorkerTimeOut : null,
                isEditingAlert : false //Stop Auto Refresh if is True
            }
        },
        created(){
            this.checkForAlertsWorker();
            const component = this;
            document.addEventListener("visibilitychange", function() {
                if(document.visibilityState === 'visible'){
                    component.checkForAlertsWorker();
                }
            });
        },
        methods: {
            openUnSnoozedAlert(alertMessage){
                if(alertMessage.type !== 'worker_credit'){
                    if(!alertMessage.is_snoozed){
                        alertMessage.isConfirmationMessageOpen = true;
                        this.isEditingAlert = true;
                        this.hasUnSnoozedAlert = true;
                    }
                }
            },
            checkExistingSnoozedAlert(){
              let flag = false;
              if(this.alertsWorker.length >= 1){
                  if (this.alertsWorker.length === 1 && this.alertsWorker[0].type === 'worker_credit') {
                      flag = false;
                  } else {
                      for(let i = 0; i < this.alertsWorker.length; i++){
                          if(!this.alertsWorker[i].is_snoozed){
                              flag = true;
                          }
                      }
                  }
              }
              this.hasUnSnoozedAlert = flag;
            },
            openAlert(alertMessage){
                if(alertMessage.is_snoozed){
                    alertMessage.isConfirmationMessageOpen = !alertMessage.isConfirmationMessageOpen;
                    this.isEditingAlert = alertMessage.isConfirmationMessageOpen;
                }
            },
            generateLinkForPdf(documentId){
              return  process.env.VUE_APP_API_BASE_URL + Routing.generate('worker_interface_generate_pdf', {id: documentId, action : 'generate'});
            },
            async setAlertAsClosed(alertMessage, alertMessageIndex) {
                this.alertsWorker.splice(alertMessageIndex, 1);
                await this.$api.alert.setAlertAsClosed(alertMessage.id);
                this.checkExistingSnoozedAlert();
                clearInterval(this.checkIfalertsWorkerTimeOut);
                this.checkExistingSnoozedAlert();
                this.isEditingAlert = false;
            },
            async hideAlert(alertMessageIndex) {
                this.alertsWorker.splice(alertMessageIndex, 1);
                this.checkExistingSnoozedAlert();
                clearInterval(this.checkIfalertsWorkerTimeOut);
                this.isEditingAlert = false;
            },
            async checkForAlertsWorker() {
                if(this.isEditingAlert === false){
                    const response = await this.$api.alert.getAlertsOfWorker(this.user.user_id);
                    this.alertsWorker = response.alertsWorker.map((alertMessage)=>{
                        alertMessage.isConfirmationMessageOpen = false;
                        alertMessage.confirmationMessage = '';
                        return alertMessage;
                    });
                    if(this.checkIfalertsWorkerTimeOut !== null){
                        clearInterval(this.checkIfalertsWorkerTimeOut);
                        this.checkIfalertsWorkerTimeOut= null;
                    }
                    if(document.visibilityState === 'visible'){
                        this.getAlertsWorkerContinuously();
                    }
                }
            },
            async snoozeAlert(alertMessage, alertMessageIndex, snoozeHours){
                if(!this.isSnoozedTimerEnable){
                    alertMessage.snoozeHours = snoozeHours;
                    this.alertsWorker[alertMessageIndex].is_snoozed = true;
                    alertMessage.is_snoozed = true;
                    try{
                        await this.$api.alert.snoozeAlert(alertMessage);
                    } catch (e) {
                        this.checkExistingSnoozedAlert();
                        this.isEditingAlert = false;
                        this.alertsWorker[alertMessageIndex].isConfirmationMessageOpen = false;
                        this.isSnoozedTimerEnable = false;
                        return;
                    }
                    this.isSnoozedTimerEnable = true;
                    let taskCreatedAt = new Date(alertMessage.created_at);
                    let now = new Date();
                    let diffInTime = now.getTime() - taskCreatedAt.getTime();
                    let diffInDays = diffInTime / (1000 * 3600 * 24);
                    this.timeEnableViewSecond = (Math.floor(diffInDays) * 3);
                    // Limit the waiting time to 15 seconds
                    this.timeEnableViewSecond = this.timeEnableViewSecond > 14 ? 15 : this.timeEnableViewSecond;

                    this.$scrollTo(this.$refs['snoozed-block'], 2000);
                    let interval = setInterval(() => {
                        this.timeEnableViewSecond--;
                        if(this.timeEnableViewSecond <= 0){
                            this.checkExistingSnoozedAlert();
                            this.isEditingAlert = false;
                            this.alertsWorker[alertMessageIndex].isConfirmationMessageOpen = false;
                            this.isSnoozedTimerEnable = false;
                            clearInterval(interval);
                        }
                    }, 1000);
                }
            },
            getAlertsWorkerContinuously(){
                const component = this;
                let   timeIntervale = 15*1000;
                this.checkIfalertsWorkerTimeOut = setInterval(function() {
                    component.checkForAlertsWorker();
                }, timeIntervale);
                this.checkExistingSnoozedAlert();
            },
            isCreationDateNotTooOld(taskDate){

                let dateOfTask = new Date(Date.parse(taskDate.toString()));
                dateOfTask = dateOfTask.setDate(dateOfTask.getDate() + 1);
                let today = new Date().getTime();
                //return ((today <= dateOfTask) ? true : false );
                return true;
            }
        },
        components: {
			AlertBadges,
            AlertJobWarranty,
            AlertDevis,
            AlertInformation,
            AlertWorkerCredit,
            AlertMissingWorkerLogo,
            AlertMissedJobs
        }
    }
</script>

<style scoped>
    .close-btn{
        position:absolute;
        right:-7px;
        top:-7px;
    }

    .alertsWorker .alert-block{
        position:relative;
    }

    .fade-enter{
        opacity: 0;
    }
    .overlay_snoozed{
        background: rgba(255, 255, 255, 0.8);
        height: 100%;
        position: absolute;
        top: inherit;
        left: 0;
        z-index: 1;
        width: 100%;
        text-align: center;
    }
</style>

<style>
    .close-btn{
        position:absolute;
        right:-7px;
        top:-7px;
    }

    .title-message-open-alert{
        width: 100%;
        display: inline-block;
    }
</style>
